import { useLayoutEffect, useRef, useState, type RefObject } from 'react';

export interface ElementSize {
    width: number;
    height: number;
}

/** The content size of an element, kept up to date with a `ResizeObserver`. */
export function useElementSize<T extends HTMLElement>() : [RefObject<T | null>, ElementSize] {
    const ref = useRef<T>(null);
    const [size, setSize] = useState<ElementSize>({ width: 0, height: 0 });

    useLayoutEffect(() => {
        const element = ref.current;
        if (!element) {
            return;
        }

        const observer = new ResizeObserver((entries) => {
            const box = entries[0]?.contentRect;
            if (box) {
                setSize({ width: box.width, height: box.height });
            }
        });
        observer.observe(element);

        return () => observer.disconnect();
    }, []);

    return [ref, size];
}
